import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import WorkOrder from "../views/WorkOrder.vue";
import List from "../views/List.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/wo/:jobnumber",
    component: WorkOrder,
  },
  { path: "/list", component: List },
];

const router = new VueRouter({
  routes,
});

export default router;
